"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaTheme = _interopRequireDefault(require("@thinkific/toga-theme"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shortid = _interopRequireDefault(require("shortid"));

var _Checkbox = _interopRequireDefault(require("./Checkbox.css"));

var _checkboxCSS = _interopRequireDefault(require("./checkboxCSS"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &&& {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var cx = _bind["default"].bind(_Checkbox["default"]);

var StyledContainer = _styledComponents["default"].div(_templateObject(), _checkboxCSS["default"]);

var Checkbox = /*#__PURE__*/function (_Component) {
  _inherits(Checkbox, _Component);

  var _super = _createSuper(Checkbox);

  function Checkbox(_props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          onChange = _this$props.onChange;
      if (isDisabled) return;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      e.persist();

      _this.setState(function (prevState) {
        return {
          isChecked: !prevState.isChecked
        };
      }, function () {
        var isChecked = _this.state.isChecked;
        onChange({
          nativeEvent: e.nativeEvent,
          target: _objectSpread({}, props, {
            checked: isChecked
          }),
          stopPropagation: function stopPropagation() {
            e.stopPropagation();
          },
          preventDefault: function preventDefault() {
            e.preventDefault();
          }
        });
      });
    });

    _this.state = {
      isChecked: _this.props.isChecked // eslint-disable-line react/destructuring-assignment

    };
    _this.el = {};
    return _this;
  }

  _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          isChecked = _this$props2.isChecked,
          isIndeterminate = _this$props2.isIndeterminate;
      this.el.isIndeterminate = isIndeterminate;
      this.el.isChecked = isChecked; // fix for IE8
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        isChecked: nextProps.isChecked
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isIndeterminate = this.props.isIndeterminate;

      if (prevProps.isIndeterminate !== isIndeterminate) {
        // not sure why this is here, I'm just migrating the code
        // setTimeout(() => {
        //   this.el.indeterminate = isIndeterminate
        // }, 0)
        this.el.indeterminate = isIndeterminate;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          labelClass = _this$props3.labelClass,
          labelText = _this$props3.labelText,
          isDisabled = _this$props3.isDisabled,
          name = _this$props3.name;
      var isChecked = this.state.isChecked;

      var localId = id || _shortid["default"].generate();

      return /*#__PURE__*/_react["default"].createElement(_togaTheme["default"].Consumer, null, function (theme) {
        return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
          "aria-checked": isChecked,
          className: cx('custom-control', 'custom-checkbox', {
            'custom-checkbox--no-label': !labelText
          }),
          disabled: isDisabled,
          role: "checkbox",
          tabIndex: "0",
          theme: theme,
          onKeyPress: _this2.handleChange
        }, /*#__PURE__*/_react["default"].createElement("input", {
          checked: isChecked,
          className: cx('custom-control-input'),
          disabled: isDisabled,
          id: localId,
          name: name,
          ref: function ref(el) {
            _this2.el = el;
          },
          type: "checkbox",
          onChange: _this2.handleChange
        }), /*#__PURE__*/_react["default"].createElement("label", {
          className: cx('custom-control-label', labelClass, {
            'custom-control-label--empty': !labelText
          }),
          htmlFor: localId
        }, labelText));
      });
    }
  }]);

  return Checkbox;
}(_react.Component);

Checkbox.propTypes = {
  id: _propTypes["default"].string,
  isChecked: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  isIndeterminate: _propTypes["default"].bool,
  labelClass: _propTypes["default"].string,
  labelText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func
};
Checkbox.defaultProps = {
  id: null,
  isChecked: false,
  isDisabled: null,
  isIndeterminate: false,
  labelText: '',
  labelClass: null,
  name: null,
  onChange: function onChange() {}
};
var _default = Checkbox;
exports["default"] = _default;